import Category from '@/components/Category'
import { PopularCategoriesSection } from '@/shared/api-generated-types'
import CardRow from '@/widgets/CardRow'
import * as styles from './style'

export interface Props extends Partial<PopularCategoriesSection> {}

const PopularCategoryBlock = ({ title, items, navigationActions }: Props): JSX.Element | null => {
  if (!items?.length) return null
  return (
    <CardRow categoryCard title={title} navigationActions={navigationActions}>
      {items.map((item, index) => (
        <div key={index} className={`${styles.itemContainer} mr-0`}>
          <Category {...item} />
        </div>
      ))}
    </CardRow>
  )
}
export default PopularCategoryBlock
